module.exports = __webpack_public_path__ + "static/media/aftertop1.6c275997.png";